import { gql } from "@apollo/client";

const GET_OUTGOING_TRAINEESHIP = gql`
  query Traineeship($id: String!) {
  traineeship(ID: $id) {
    traineeshipID
    traineeship_id
    title
    created
    changed
    field_tr_status
    field_tr_ewp_id
    field_tr_student_firstname
    field_tr_student_lastname
    field_tr_student_email
    field_tr_student_birthdate
    field_tr_student_field_of_edu_cl
    field_tr_dashboard_student_email
    field_tr_status_certificate
    gender
    nationality
    isced
    student_study_cycle
    language
    language_competence
    sending_institution
    receiving_organization
    sending_contact_person
    receiving_contact_person
    receiving_mentor
    table_a
    table_b
    table_b_type
    table_b_accident_insurance {
      field_acc_cov_way
      field_acc_cov_travel
      field_acc_ins_liability
      field_acc_ins
    }
    table_c
    table_c_accident_insurance {
      field_acc_cov_way
      field_acc_cov_travel
      field_acc_ins_liability
      field_acc_ins
    }
    table_d {
      field_tr_tbl_d_title
      field_tr_tbl_d_trainee
      field_tr_tbl_d_sta_per_complete
      field_tr_tbl_d_end_per_complete
      field_tr_tbl_d_sta_per_physical
      field_tr_tbl_d_end_per_physical
      field_tr_tbl_d_rec_org
      field_tr_tbl_d_rec_org_add
      field_tr_tbl_d_rec_org_sec
      field_tr_tbl_d_rec_org_web
      field_tr_tbl_d_program
      field_tr_tbl_d_knowledge
      field_tr_tbl_d_evaluation
    }
    final_table_a2
    commitment_preliminary
    commitment_final
    revisions
  }
}`
;

export default GET_OUTGOING_TRAINEESHIP;
